var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudent2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.285,
    height: 77.038,
    viewBox: "0 0 58.285 77.038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-teacher-2463963",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6422",
    "data-name": "Path 6422",
    d: "M55.123,68.612a.673.673,0,0,1-.673-.673V63.723a.673.673,0,1,1,1.347,0v4.215a.673.673,0,0,1-.673.673Z",
    transform: "translate(-31.718 -25.174)",
    fill: "#f7edd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6423",
    "data-name": "Path 6423",
    d: "M21.363,104.261a.673.673,0,0,1-.673-.673v-13.9a14.948,14.948,0,0,1,7.521-11.528L43.766,69.4a.673.673,0,0,1,.633,0L49.785,72.1,55.172,69.4a.673.673,0,0,1,.633,0l15.554,8.753a14.962,14.962,0,0,1,7.616,13.022V103.52a.673.673,0,0,1-.673.673l-56.985.061Zm.673-14.47v13.123l55.638-.061V91.178a13.615,13.615,0,0,0-6.949-11.851L55.5,70.748l-5.387,2.693a.673.673,0,0,1-.606,0l-5.387-2.693L28.871,79.327a13.6,13.6,0,0,0-6.834,10.457Z",
    transform: "translate(-20.69 -27.223)",
    fill: "#f7edd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6424",
    "data-name": "Path 6424",
    d: "M79.844,66.209a.673.673,0,0,1-.229-1.306l7.777-2.781a.754.754,0,0,0,.471-.916l-3.905-13.7a.673.673,0,0,1,1.293-.37l3.905,13.7a2.108,2.108,0,0,1-1.347,2.552l-7.737,2.781A.674.674,0,0,1,79.844,66.209Z",
    transform: "translate(-39.793 -19.828)",
    fill: "#f7edd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6425",
    "data-name": "Path 6425",
    d: "M43.119,66.209a.673.673,0,0,1-.229-.04l-7.777-2.774A2.1,2.1,0,0,1,33.8,60.835l3.912-13.7a.673.673,0,0,1,1.293.37L35.1,61.206a.754.754,0,0,0,.471.916L43.335,64.9a.673.673,0,0,1-.229,1.306Z",
    transform: "translate(-24.946 -19.828)",
    fill: "#f7edd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6426",
    "data-name": "Path 6426",
    d: "M54.254,55.612a16.275,16.275,0,0,1-15.8-12.12,4.242,4.242,0,0,1-.566-8.43V33.533a.673.673,0,1,1,1.347,0v2.114a.673.673,0,0,1-.673.673,2.9,2.9,0,1,0,0,5.791,1.521,1.521,0,0,0,.209,0h.121a.673.673,0,0,1,.734.518,15.009,15.009,0,0,0,29.257,0,.673.673,0,0,1,.734-.518h.128a1.556,1.556,0,0,0,.209,0,2.9,2.9,0,1,0,0-5.791.673.673,0,1,1,0-1.347,4.242,4.242,0,0,1,.108,8.477,16.275,16.275,0,0,1-15.8,12.161Z",
    transform: "translate(-25.139 -15.312)",
    fill: "#f7edd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6427",
    "data-name": "Path 6427",
    d: "M56.759,90.555a11.3,11.3,0,0,1-10.221-6.377l-2.525-5.1a.675.675,0,0,1,1.212-.593l2.5,5.1a10.026,10.026,0,0,0,18.019,0l4.208-8.6-7.5-4.235-5.387,2.693a.673.673,0,0,1-.606,0l-5.387-2.693L42.989,75.3a.676.676,0,0,1-.673-1.172l8.39-4.713a.673.673,0,0,1,.633,0l5.387,2.693,5.387-2.693a.673.673,0,0,1,.633,0l8.39,4.713a.673.673,0,0,1,.276.882l-4.437,9.171A11.3,11.3,0,0,1,56.759,90.555Z",
    transform: "translate(-27.643 -27.226)",
    fill: "#f7edd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6428",
    "data-name": "Path 6428",
    d: "M72.083,68.612a.673.673,0,0,1-.673-.673V63.723a.673.673,0,1,1,1.347,0v4.215A.673.673,0,0,1,72.083,68.612Z",
    transform: "translate(-37.258 -25.174)",
    fill: "#f7edd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6429",
    "data-name": "Path 6429",
    d: "M36.053,113.535a.673.673,0,0,1-.673-.673V98.593a.673.673,0,0,1,1.347,0v14.268A.673.673,0,0,1,36.053,113.535Z",
    transform: "translate(-25.489 -36.564)",
    fill: "#f7edd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6430",
    "data-name": "Path 6430",
    d: "M91.153,113.535a.673.673,0,0,1-.673-.673V98.593a.673.673,0,0,1,1.347,0v14.268A.673.673,0,0,1,91.153,113.535Z",
    transform: "translate(-43.487 -36.564)",
    fill: "#f7edd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6431",
    "data-name": "Path 6431",
    d: "M51.836,41.712a4.956,4.956,0,1,1,4.956-4.956,4.956,4.956,0,0,1-4.956,4.956Zm0-8.565a3.609,3.609,0,1,0,3.609,3.609A3.609,3.609,0,0,0,51.836,33.147Z",
    transform: "translate(-29.245 -14.966)",
    fill: "#f7edd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6432",
    "data-name": "Path 6432",
    d: "M71.222,41.712a4.956,4.956,0,1,1,4.969-4.956,4.956,4.956,0,0,1-4.969,4.956Zm0-8.565A3.609,3.609,0,1,0,73.783,34.2,3.609,3.609,0,0,0,71.222,33.147Z",
    transform: "translate(-35.582 -14.966)",
    fill: "#f7edd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6433",
    "data-name": "Path 6433",
    d: "M61.885,53.846a6.377,6.377,0,0,1-4-1.421.673.673,0,0,1,.842-1.05,5.01,5.01,0,0,0,6.289,0l.835,1.05A6.336,6.336,0,0,1,61.885,53.846Z",
    transform: "translate(-32.763 -21.316)",
    fill: "#f7edd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6434",
    "data-name": "Path 6434",
    d: "M45.263,37.347H40.293a.673.673,0,0,1,0-1.347h4.969a.673.673,0,0,1,0,1.347Z",
    transform: "translate(-26.874 -16.338)",
    fill: "#f7edd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6435",
    "data-name": "Path 6435",
    d: "M84.49,37.347h-5a.673.673,0,0,1,0-1.347h5a.673.673,0,1,1,0,1.347Z",
    transform: "translate(-39.678 -16.338)",
    fill: "#f7edd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6436",
    "data-name": "Path 6436",
    d: "M64.89,37.347h-5a.673.673,0,1,1,0-1.347h5a.673.673,0,0,1,0,1.347Z",
    transform: "translate(-33.276 -16.338)",
    fill: "#f7edd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6437",
    "data-name": "Path 6437",
    d: "M63.6,91.942a.673.673,0,0,1-.673-.673V74.253a.673.673,0,1,1,1.347,0V91.269A.673.673,0,0,1,63.6,91.942Z",
    transform: "translate(-34.488 -28.613)",
    fill: "#f7edd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6438",
    "data-name": "Path 6438",
    d: "M82.405,30.229a.673.673,0,0,1-.492-.215l-9.279-9.959a.673.673,0,0,1,0-.949l5-4.713a.673.673,0,0,1,.465-.182,4.963,4.963,0,0,1,4.956,4.956v10.39a.673.673,0,0,1-.646.673ZM74.076,19.624l7.656,8.242v-8.7a3.609,3.609,0,0,0-3.367-3.6Z",
    transform: "translate(-37.594 -9.22)",
    fill: "#f7edd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6439",
    "data-name": "Path 6439",
    d: "M37.033,23.337a.673.673,0,0,1-.673-.673v-.916a10.078,10.078,0,0,1,.047-1.192c-.1-.828-.512-6.552,6.834-11.4A14.564,14.564,0,0,1,51.322,6.8H62.493a4.229,4.229,0,0,1,2.855,7.36l-3.609,3.286a.673.673,0,0,1-.3.155L37.2,23.31ZM51.3,8.14A13.225,13.225,0,0,0,43.982,10.3h0c-7.036,4.646-6.242,10.1-6.235,10.141a.673.673,0,0,1,0,.162c0,.377-.047.768-.047,1.151v.074l23.264-5.468L64.438,13.2A2.9,2.9,0,0,0,62.492,8.16Zm-7.69,1.576Z",
    transform: "translate(-25.809 -6.799)",
    fill: "#f7edd6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent2);
export default __webpack_public_path__ + "static/media/student2.dd8343534ef90a7375b96ac04ca623ec.svg";
export { ForwardRef as ReactComponent };